import useOnlineStations from "./useOnlineStations";
import useStationSearch from "./useStationSearch";

// Opcije za polje stanice u formi pretrage. Bez kucanja: puna lista stanica sa
// polascima za dati datum (predlog „šta danas vozi"). Kucanjem (2+ slova) se
// prelazi na serversku pretragu po imenu preko SVIH stanica — relacija koja ne
// vozi izabranog dana mora ostati izabirljiva (pretraga onda kaže „nema
// polazaka" i ponudi prvi sledeći dan). Ako dnevni endpoint nije dostupan,
// tiho pada na staru pretragu po imenu — forma nikad ne ostaje bez stanica.
export default function useStationOptions(journeyDate, fromStationId = null) {
    const online = useOnlineStations(journeyDate, fromStationId);
    const legacy = useStationSearch();
    const onlineMode = online.stations !== null;
    const typing = legacy.input.trim().length >= 2;
    const useLegacy = !onlineMode || typing;

    return {
        onlineMode,
        // Opcije sa servera su već filtrirane po kucanju — Autocomplete tada ne
        // sme da filtrira ponovo (server može da pogodi i po lokaciji, ne samo
        // po vidljivom imenu).
        serverFiltered: useLegacy,
        options: useLegacy ? legacy.stations : online.stations,
        loading: useLegacy ? legacy.loading : online.loading,
        input: legacy.input,
        setInput: legacy.setInput,
    };
}
